export default __webpack_public_path__ + "static/media/our-work-poster.22226d5f.webp";